import * as React from "react";
import {
  ArkoseCAPTCHAContext,
  IArkoseCAPTCHAConsumerProps,
} from "./ArkoseCAPTCHAProvider";

export const useArkoseCAPTCHA = () => {
  const context = React.useContext(ArkoseCAPTCHAContext);
  guardContext(context);
  return context;
};

declare const process: any;

function guardContext(context: IArkoseCAPTCHAConsumerProps) {
  if (typeof process !== "undefined") {
    return;
  }
  if (!context.initiated) {
    console.warn(`
        ArkoseCAPTCHAContext not initiated
        Are you sure you have added the ArkoseCAPTCHAProvider to your app?
        ReactDom.render(
          <ArkoseCAPTCHAProvider publickey="[your public key]">
            <App />
          </ArkoseCAPTCHAProvider>,
          document.getElementById("app")
        );`);
  }
}
